import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { hasHandlebars } from 'modules/templateEditor/common/utils';
import { colors } from 'ui/theme';
import { NegativeFill } from 'ui/icons';

import { displayContent } from '../common/content';
import { SETTINGS_DISPLAY_CONTENT } from './constants';

// import { SMSSender } from 'modules/graphql/types';
// import { TrackingDomain } from 'modules/mailDomains/types';
// import { ApiResponse, postRaw } from 'services/api';

// import { OS } from '../common/types';

// /** Format SMS senders data into what is expected for options value in BasicSelect */
// export const formatSMSSenders = (smsSenders: SMSSender[]) =>
//   smsSenders.map((sender) => ({
//     doubleLine: sender.phoneNumber,
//     id: sender.id.toString(),
//     label: sender.name,
//     value: sender.id.toString(),
//   }));

// /** Format SMS senders data into what is expected for options value in FilterSelect */
// export const formatTrackingDomains = (trackingDomains: TrackingDomain[]) =>
//   trackingDomains.map(({ domain }: { domain: string }) => ({
//     id: domain,
//     label: domain,
//     value: domain,
//   }));

// /**
//  * Returns truncated SMS notification message (lock screen)
//  * @see {@link https://support.airship.com/hc/en-us/articles/213491643-What-are-the-Maximum-Characters-for-Push-Notifications-}
//  * @param {OS} selectedOs - enum for the OS being rendered
//  * @param {string} [message] - any text string
//  * @returns {string} truncated SMS (lock screen) notification message
//  */
// export const getNotificationMsg = (selectedOs: OS, message = '') => {
//   const trimmedMsg = message.trim();
//   const msgMax = selectedOs === OS.ios ? 150 : 40;
//   return trimmedMsg.length > msgMax ? (
//     <>{trimmedMsg.slice(0, msgMax).trim()}&hellip;</>
//   ) : (
//     trimmedMsg
//   );
// };

// export const getFullMessage = (message: string, optOutDisclaimer: string) => {
//   return optOutDisclaimer ? `${message}\n${optOutDisclaimer}` : message;
// };

const HandlebarsMessageWrapper = styled.div`
  display: grid;
  grid-template-columns: 0fr 1fr;
  grid-gap: ${pxToRem(6)};
`;

export const RestrictionTextForHandleBar = (
  <HandlebarsMessageWrapper>
    <NegativeFill color={colors.textSecondary} />
    <span>{SETTINGS_DISPLAY_CONTENT.handlebarsRestrictionText}</span>
  </HandlebarsMessageWrapper>
);

export const getRestrictionText = (msg = '', isEditMode: boolean) => {
  if (!isEditMode) {
    return '';
  }

  if (hasHandlebars(msg)) {
    return RestrictionTextForHandleBar;
  }

  return <>{`${displayContent.strCharacterLength({ charCount: msg?.length || 0 })}`}</>;
};
